export const tokens = {
    list: {
        gap: 10,
    },
    item: {
        fontSize: 16,
    },
};
